import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import Cookies from 'js-cookie'

Vue.use(ElementUI, { size: 'medium' })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  created() {
    if (Cookies.get('admin_token')) {
      const adminInfo = localStorage.getItem('adminInfo')
      if (adminInfo) {
        try {
          this.$store.dispatch('setAdminInfo', JSON.parse(adminInfo))
        } catch (e) {
          console.error('Failed to parse adminInfo from localStorage', e)
        }
      }
    }
  },
  render: h => h(App)
}).$mount('#app')
